import type { ReactNode } from 'react'

import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

type SettingRowProps = {
  label: string
  htmlFor?: string
  labelClassName?: string
  children: ReactNode
}

/** リーダーの設定 1 項目（ラベル＋操作）を 1 行で並べる */
export const SettingRow = ({ label, htmlFor, labelClassName, children }: SettingRowProps) => (
  <div className="flex min-h-8 items-center gap-3">
    <Label htmlFor={htmlFor} className={cn('w-18 shrink-0 text-sm font-medium', labelClassName)}>
      {label}
    </Label>
    <div className="flex min-w-0 flex-1 items-center justify-end gap-2">{children}</div>
  </div>
)

export type SegmentedOption<T extends string> = { value: T; label: string; title?: string }

type SegmentedProps<T extends string> = {
  options: SegmentedOption<T>[]
  value: T | null
  onChange: (value: T) => void
}

export const Segmented = <T extends string>({ options, value, onChange }: SegmentedProps<T>) => (
  <div className="flex min-w-0 flex-1 rounded-md bg-muted p-0.5">
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        title={option.title}
        aria-pressed={value === option.value}
        onClick={() => onChange(option.value)}
        className={cn(
          'flex-1 whitespace-nowrap rounded-sm px-1.5 py-1 text-xs font-medium transition-colors',
          value === option.value
            ? 'bg-primary text-primary-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground',
        )}
      >
        {option.label}
      </button>
    ))}
  </div>
)
